import React, { useState } from "react";
import {
  TextField,
  Button,
  Typography,
  Paper,
  Box,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import api from "../services/api";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  container: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f3f4f6",
  },
  paper: {
    padding: theme.spacing(4),
    maxWidth: 400,
    width: "100%",
    textAlign: "center",
    borderRadius: 12,
  },
  title: {
    marginBottom: theme.spacing(3),
    fontWeight: 600,
    color: "#1f2937",
  },
  textField: {
    marginBottom: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(2),
    backgroundColor: "#16a34a",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#15803d",
    },
  },
  link: {
    marginTop: theme.spacing(2),
    color: "#2563eb",
    cursor: "pointer",
  },
}));

export default function Login({ onLoginSuccess }) {
  const classes = useStyles();
  const history = useHistory();

  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const { data } = await api.post("/auth/login", { email, senha });

      if (data?.token) {
        localStorage.setItem("token", data.token);

        if (onLoginSuccess) onLoginSuccess(); // ✅ avisa o App que logou
        toast.success("Login realizado com sucesso!");
        history.push("/chat");
      } else {
        toast.error("E-mail ou senha inválidos");
      }
    } catch (err) {
      console.error(err);
      toast.error("Erro ao fazer login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className={classes.container}>
      <Paper className={classes.paper} elevation={3}>
        <Box className={classes.logoContainer} style={{ justifyContent: 'center', marginBottom: 16 }}>
          <img
            src="/whatsdelivery2.png"
            alt="WhatsDelivery"
            style={{ height: 100 }}
          />
        </Box>
        <Typography variant="h6" color="textSecondary">
          Login
        </Typography>

        <form onSubmit={handleSubmit}>
          <TextField
            label="E-mail"
            type="email"
            fullWidth
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={classes.textField}
          />

          <TextField
            label="Senha"
            type="password"
            fullWidth
            variant="outlined"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            className={classes.textField}
          />

          <Button
            fullWidth
            type="submit"
            variant="contained"
            className={classes.button}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : "Entrar"}
          </Button>
        </form>

        {/* <Typography
          className={classes.link}
          onClick={() => history.push("/register")}
          disabled={true}
        >
          Criar nova conta
        </Typography> */}
      </Paper>
    </Box>
  );
}
